// Company facts approval register (code side). Every flag stays false until the owner confirms the fact.
// Unapproved facts are omitted from public HTML, metadata and JSON-LD. See /app/memory/seo/review/G_company_facts_register.md
export const FACTS_APPROVED = {
  contact: true,       // business email, telephone, WhatsApp number
  address: true,       // Moradabad office address
  founderTitle: true,  // "Dr. Sumit Chhabra — Founder & CEO" and public biography
  stats: true,         // years of experience, factory count, countries served
  clusters: false,      // manufacturing clusters actually used by Sourcing India
  social: false,        // official social profiles (none supplied)
};

export const SHOW_CONTACT = FACTS_APPROVED.contact;
